// extracted by mini-css-extract-plugin
export default {"error-container":"FetchError_error-container__iQuJU"};